var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticStyle: {
        "background-color": "rgb(243, 243, 243) !important",
        width: "105%",
        "margin-left": "-10px",
        padding: "0 0px 0px 0px !important"
      }
    },
    [
      _c(
        "div",
        { staticClass: "pt-4" },
        [
          _c(
            "v-row",
            {
              staticClass: "mb-1",
              staticStyle: { "padding-top": "15px" },
              attrs: { justify: "space-between", "no-gutters": "" }
            },
            [
              _c(
                "v-col",
                [
                  _c(
                    "v-dialog",
                    {
                      ref: "dateDialog",
                      attrs: {
                        "return-value": _vm.dateRange,
                        persistent: "",
                        width: "280px"
                      },
                      on: {
                        "update:returnValue": function($event) {
                          _vm.dateRange = $event
                        },
                        "update:return-value": function($event) {
                          _vm.dateRange = $event
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  {
                                    staticStyle: {
                                      "margin-top": "20px",
                                      width: "90%",
                                      margin: "0px auto"
                                    },
                                    attrs: {
                                      dense: "",
                                      label: "Click to select date range",
                                      "prepend-icon": "mdi-calendar",
                                      readonly: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.dateRange = []
                                      }
                                    },
                                    model: {
                                      value: _vm.dateRangeText,
                                      callback: function($$v) {
                                        _vm.dateRangeText = $$v
                                      },
                                      expression: "dateRangeText"
                                    }
                                  },
                                  on
                                )
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.dateModal,
                        callback: function($$v) {
                          _vm.dateModal = $$v
                        },
                        expression: "dateModal"
                      }
                    },
                    [
                      _c(
                        "v-date-picker",
                        {
                          attrs: {
                            min: "2019-01-01",
                            max: new Date().toISOString().substr(0, 10),
                            scrollable: "",
                            range: ""
                          },
                          model: {
                            value: _vm.dateRange,
                            callback: function($$v) {
                              _vm.dateRange = $$v
                            },
                            expression: "dateRange"
                          }
                        },
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.dateModal = false
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.fetchData()
                                }
                              }
                            },
                            [_vm._v("GENERATE")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "v-row",
            { staticStyle: { "margin-bottom": "40px" } },
            [
              _c(
                "v-col",
                { attrs: { lg: "6" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "report-card",
                      attrs: { loading: _vm.currentlyLoading.users, id: "left" }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "report-card-icon",
                          attrs: { disabled: "", color: "#48bb78" }
                        },
                        [_vm._v("mdi-chart-line")]
                      ),
                      _vm.totalUsers <= 999
                        ? _c(
                            "v-card-title",
                            {
                              staticClass: "report-card-data",
                              on: {
                                click: function($event) {
                                  _vm.totalUserChart = true
                                }
                              }
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.totalUsers) + " "),
                              _c(
                                "span",
                                {
                                  staticClass: "report-card-data-unit",
                                  staticStyle: { visibility: "hidden" }
                                },
                                [_vm._v("MB")]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.totalUsers > 999
                        ? _c(
                            "v-card-title",
                            {
                              staticClass: "report-card-data",
                              on: {
                                click: function($event) {
                                  _vm.totalUserChart = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    parseFloat(_vm.totalUsers / 1000).toFixed(1)
                                  ) +
                                  " "
                              ),
                              _c(
                                "span",
                                { staticClass: "report-card-data-unit" },
                                [_vm._v("K")]
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "v-card-title",
                        { staticClass: "fs-14 py-1 pl-3 report-card-label" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "pr-1 fw-500 text-uppercase",
                              staticStyle: {
                                color: "#48bb78",
                                "font-size": "3.7vw"
                              }
                            },
                            [_vm._v("Total Users")]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                bottom: "",
                                "max-width": "207",
                                "max-height": "57"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          { staticClass: "help-icon" },
                                          on
                                        ),
                                        [_vm._v("mdi-help")]
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Total Number of Wifi Users seen in the Range Selected"
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { lg: "6" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "report-card",
                      attrs: { loading: _vm.currentlyLoading.data, id: "right" }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "report-card-icon",
                          attrs: { disabled: "", color: "#214294" }
                        },
                        [_vm._v("mdi-chart-line")]
                      ),
                      _vm.totalDataUsed >= 0.1 && _vm.totalDataUsed < 99
                        ? _c(
                            "v-card-title",
                            { staticClass: "report-card-data" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.roundTo(_vm.totalDataUsed, 1)) +
                                  " "
                              ),
                              _c(
                                "span",
                                { staticClass: "report-card-data-unit" },
                                [_vm._v("GB")]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.totalDataUsed >= 0.1 && _vm.totalDataUsed >= 99
                        ? _c(
                            "v-card-title",
                            { staticClass: "report-card-data" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.roundTo(_vm.totalDataUsed, 0)) +
                                  " "
                              ),
                              _c(
                                "span",
                                { staticClass: "report-card-data-unit" },
                                [_vm._v("GB")]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.totalDataUsed < 0.1
                        ? _c(
                            "v-card-title",
                            { staticClass: "report-card-data" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(parseInt(_vm.totalDataUsed * 1024)) +
                                  " "
                              ),
                              _c(
                                "span",
                                { staticClass: "report-card-data-unit" },
                                [_vm._v("MB")]
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "v-card-title",
                        { staticClass: "fs-14 py-1 pl-3 report-card-label" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "pr-1 fw-500 text-uppercase",
                              staticStyle: {
                                color: "#214294",
                                "font-size": "3.7vw"
                              }
                            },
                            [_vm._v("Data Used")]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                bottom: "",
                                "max-width": "207",
                                "max-height": "57"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          { staticClass: "help-icon" },
                                          on
                                        ),
                                        [_vm._v("mdi-help")]
                                      )
                                    ]
                                  }
                                }
                              ])
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Total Data Consumed by Wifi Users in the Range Selected"
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        style: {
          "padding-bottom": _vm.endUserDataArray.length > 0 ? "20px" : "0px"
        },
        attrs: {
          loading: _vm.currentlyLoading.report,
          "loading-text": "Fetching Report",
          headers: _vm.headers,
          items: _vm.endUserDataArray,
          "single-expand": _vm.singleExpand,
          expanded: _vm.expanded,
          "item-key": "mkey",
          "mobile-breakpoint": "",
          "disable-pagination": "",
          "hide-default-footer": true,
          "must-sort": true,
          "sort-by": "date",
          "sort-desc": true
        },
        on: {
          "update:expanded": function($event) {
            _vm.expanded = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "v-menu",
                  {
                    attrs: {
                      transition: "slide-y-transition",
                      bottom: "",
                      "offset-y": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticStyle: {
                                    position: "absolute",
                                    right: "0",
                                    height: "40px",
                                    width: "40px",
                                    "background-color":
                                      "transparent !important",
                                    "border-radius": "0px !important",
                                    overflow: "hidden"
                                  },
                                  attrs: {
                                    text: "",
                                    color: "black",
                                    icon: "",
                                    disabled: _vm.endUserDataArray.length == 0
                                  }
                                },
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { color: "white" } }, [
                                  _vm._v("mdi-dots-vertical")
                                ])
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _c(
                      "v-list",
                      { attrs: { color: "#fffaf5" } },
                      [
                        _c(
                          "v-list-item",
                          {
                            attrs: { disabled: _vm.nonPremium(), dense: "" },
                            on: {
                              click: function($event) {
                                return _vm.exportData()
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _c(
                                    "span",
                                    { attrs: { "v-if": _vm.nonPremium() } },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "25px",
                                          height: "25px"
                                        },
                                        attrs: {
                                          src: require("img/locked.svg")
                                        }
                                      })
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "fs-12 text-capitalize warm-grey",
                                      staticStyle: { "padding-bottom": "10px" }
                                    },
                                    [_vm._v("Export All Data")]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "item.status",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm.onlineUsers[item.mobile] != null
                  ? _c(
                      "v-icon",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { dense: "", "x-small": "", color: "green" }
                      },
                      [_vm._v("mdi-checkbox-blank-circle")]
                    )
                  : _vm._e(),
                _vm.onlineUsers[item.mobile] == null
                  ? _c(
                      "v-icon",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { dense: "", "x-small": "", color: "gray" }
                      },
                      [_vm._v("mdi-circle")]
                    )
                  : _vm._e()
              ]
            }
          },
          {
            key: "item.logout",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-btn",
                  {
                    style: {
                      "text-transform": "capitalize",
                      color:
                        _vm.onlineUsers[item.mobile] == null
                          ? "gray"
                          : "red !important",
                      "min-width": "22px",
                      padding: "0px"
                    },
                    attrs: {
                      "x-small": "",
                      text: "",
                      color: "black",
                      disabled: _vm.onlineUsers[item.mobile] == null
                    },
                    on: {
                      click: function($event) {
                        return _vm.logoutUser(
                          _vm.onlineUsers[item.mobile],
                          item.mobile
                        )
                      }
                    }
                  },
                  [
                    _vm.onlineUsers[item.mobile] == null
                      ? _c("img", {
                          staticStyle: {
                            height: "20px",
                            float: "right",
                            "margin-left": "10px",
                            padding: "0px 5px",
                            color: "black !important"
                          },
                          attrs: {
                            src: require("img/icons/logout_disabled.svg")
                          }
                        })
                      : _vm._e(),
                    _vm.onlineUsers[item.mobile] != null
                      ? _c("img", {
                          staticStyle: {
                            height: "20px",
                            float: "right",
                            "margin-left": "10px",
                            padding: "0px 5px",
                            color: "black !important"
                          },
                          attrs: { src: require("img/icons/logout.svg") }
                        })
                      : _vm._e()
                  ]
                )
              ]
            }
          },
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function($event) {
                        return _vm.ShowItemDetails(item)
                      }
                    }
                  },
                  [_vm._v("mdi-chevron-right")]
                )
              ]
            }
          }
        ])
      }),
      _vm.totalUserChart == true
        ? _c(
            "div",
            [
              _c(
                "v-card",
                { staticClass: "mx-auto", attrs: { "max-width": "400" } },
                [
                  _c(
                    "v-icon",
                    {
                      on: {
                        click: function($event) {
                          _vm.totalUserChart = false
                        }
                      }
                    },
                    [_vm._v("mdi-close")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.totalDataChart == true
        ? _c(
            "div",
            [
              _c(
                "v-card",
                { staticClass: "mx-auto", attrs: { "max-width": "400" } },
                [
                  _c(
                    "v-icon",
                    {
                      on: {
                        click: function($event) {
                          _vm.totalDataChart = false
                        }
                      }
                    },
                    [_vm._v("mdi-close")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          staticClass: "pl-0",
          staticStyle: {
            width: "100%",
            "padding-left": "0px !important",
            margin: "4px !important"
          },
          model: {
            value: _vm.showItemDetails,
            callback: function($$v) {
              _vm.showItemDetails = $$v
            },
            expression: "showItemDetails"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { dark: "" } },
            [
              _c(
                "v-card-text",
                { staticStyle: { padding: "0px 5px 5px 5px" } },
                [
                  Array.isArray(_vm.itemDetails) && _vm.itemDetails.length == 0
                    ? _c("v-skeleton-loader", {
                        ref: "skeleton",
                        staticClass: "mx-auto",
                        staticStyle: { "border-radius": "0px" },
                        attrs: {
                          boilerplate: false,
                          type: "list-item-three-line",
                          tile: false
                        }
                      })
                    : _vm._e(),
                  Array.isArray(_vm.itemDetails) && _vm.itemDetails.length >= 1
                    ? _c("v-simple-table", {
                        attrs: { dense: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c("thead", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-left",
                                          staticStyle: {
                                            "font-size": "10px",
                                            "padding-left": "5px",
                                            "padding-right": "0px"
                                          }
                                        },
                                        [_vm._v("MAC ID")]
                                      ),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-left",
                                          staticStyle: {
                                            "font-size": "12px",
                                            "padding-left": "5px",
                                            "padding-right": "0px"
                                          }
                                        },
                                        [_vm._v("Login Time")]
                                      ),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-left",
                                          staticStyle: {
                                            "font-size": "12px",
                                            "padding-left": "5px",
                                            "padding-right": "0px"
                                          }
                                        },
                                        [_vm._v("Logout Time")]
                                      ),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-left",
                                          staticStyle: {
                                            "font-size": "12px",
                                            "padding-left": "5px",
                                            "padding-right": "5px"
                                          }
                                        },
                                        [_vm._v("Data Used(Mb)")]
                                      )
                                    ])
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.itemDetails, function(
                                      item,
                                      $index
                                    ) {
                                      return _c(
                                        "tr",
                                        { key: "detailRow" + $index },
                                        [
                                          item
                                            ? _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "font-size": "10px",
                                                    "padding-left": "5px",
                                                    "padding-right": "0px"
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.macId))]
                                              )
                                            : _vm._e(),
                                          item
                                            ? _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "font-size": "10px",
                                                    "padding-left": "5px",
                                                    "padding-right": "0px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.startTimestamp)
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          item
                                            ? _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "font-size": "10px",
                                                    "padding-left": "5px",
                                                    "padding-right": "0px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.endTimestamp)
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          item
                                            ? _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "font-size": "10px",
                                                    "padding-left": "5px",
                                                    "padding-right": "5px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        parseInt(
                                                          _vm.formatData(
                                                            item.dataUpload +
                                                              item.dataDownload
                                                          )
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm.nonPremium()
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "border-radius": "5px",
                                            border: "solid 1px red",
                                            "margin-left": "-5px",
                                            width: "100%",
                                            "background-color":
                                              "rgba(255,255,255,0.9)",
                                            display: "block",
                                            height: "-webkit-fill-available",
                                            position: "absolute",
                                            top: "0px",
                                            "text-align": "center",
                                            "z-index": "999999"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "block",
                                                position: "relative",
                                                top: "25px"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "50px",
                                                  height: "50px"
                                                },
                                                attrs: {
                                                  src: require("img/locked.svg")
                                                }
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "block",
                                                    "font-weight": "bold",
                                                    "font-size": "16px",
                                                    color: "#000"
                                                  }
                                                },
                                                [_vm._v("Premium Feature")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3593440215
                        )
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function($event) {
                          _vm.showItemDetails = false
                        }
                      }
                    },
                    [_vm._v("Close")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function($event) {
                          return _vm.exportDetailData()
                        }
                      }
                    },
                    [_vm._v("Export Report")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }